import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '@mui/icons-material/Error';

const AttachmentError = ({
  children,
}) => (
  <>
    {children}
  </>
);

AttachmentError.propTypes = {
  children: PropTypes.node,
};

AttachmentError.defaultProps = {
  children: <ErrorIcon />,
};

export default AttachmentError;
